module.exports = __webpack_public_path__ + "img/SecondaryWaterSupply-hover.a85139f3.png";